import { IsNotEmpty, IsNumber, IsOptional, IsString, IsUrl } from 'class-validator';

export class UserAvatarFileDto {
  @IsString()
  @IsOptional()
  id?: string;

  @IsString()
  @IsNotEmpty()
  filename!: string;

  @IsNumber()
  @IsNotEmpty()
  size!: number;

  @IsUrl()
  @IsNotEmpty()
  url!: string;
}
